import React from "react";
import { TFunction } from "i18next";
import toast from "react-hot-toast";
import ToastBody from "@/components/ui/toast-body";
import { DealScoreBadge } from "@/pages/deals/components/DealScoreBadge";
import { ScoreConfig, ScoreType } from "@/pages/deals/scoreConfig";
import { IconButton } from "@/components/ui/icon-button";
import { Close } from "@dreamhub/designsystem/icons";
import { Score } from "@/pages/deals/types";
import { getScoreBadgeTooltipContent } from "@/pages/deals/components/DealKPIs";

interface QuestionnaireScoreToastContentProps {
  questionnaireName: string;
  newScore: Score | null;
  newScoreKey: ScoreConfig;
  kpiValue: string;
  t: TFunction;
}

const QuestionnaireScoreToastContent: React.FC<
  QuestionnaireScoreToastContentProps
> = ({ questionnaireName, newScore, newScoreKey, kpiValue, t }) => {
  return (
    <ToastBody
      title={
        <span className="flex items-center gap-3">
          {t(
            newScoreKey === ScoreConfig.FAILED
              ? "deals.dealView.failToast.header"
              : "deals.dealView.passToast.header",
            { questionnaireName }
          )}
          <DealScoreBadge
            scoreText={newScore?.scoreText || ""}
            scoreType={kpiValue as ScoreType}
            size="sm"
          />
        </span>
      }
      subtitle={getScoreBadgeTooltipContent(
        t,
        newScoreKey,
        kpiValue as ScoreType,
        newScore
      )}
      actions={
        <IconButton
          size="md"
          variant="iconNoBg"
          iconColor="secondary"
          onClick={() => toast.dismiss()}
        >
          <Close />
        </IconButton>
      }
    />
  );
};

export default QuestionnaireScoreToastContent;
